import baseUrl from "utils/baseUrl";
const API_ENDPOINT = baseUrl;
let isArrowOptionEnable = true;
export const toggleArrorFuntion = (type: boolean) => {
  isArrowOptionEnable = type;
  return isArrowOptionEnable;
};
export const getArrowFunction = () => {
  return isArrowOptionEnable;
};
export const service = (api = "", type = "", data = {}) => {
  try {
    return fetch(API_ENDPOINT + api, {
      method: type,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson)
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const findOne = (api = "", data: any = []) => {
  try {
    let access_token = getToken();
    return fetch(API_ENDPOINT + api + "?" + serialize(data), {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: access_token,
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        console.log(responseJson);
        if (responseJson.data) {
          return responseJson.data;
        } else {
          return responseJson.data ? responseJson.data : {};
        }
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const getData = (api = "", data: any = {}) => {
  try {
    let accessToken = getToken();
    if (accessToken !== "") {
      data.token = accessToken;
    }
    return fetch(API_ENDPOINT + api + "?" + serialize(data), {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // 'Authorization': access_token
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const postData = (api = "", data = {}) => {
  let accessToken = getToken();
  try {
    return fetch(API_ENDPOINT + api, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // 'authorization': accessToken
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson)
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const updateData = (api = "", data = {}) => {
  let accessToken = getToken();
  try {
    return fetch(API_ENDPOINT + api, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: accessToken,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson)
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const deleteData = (api = "", id = "") => {
  let accessToken = getToken();
  try {
    return fetch(API_ENDPOINT + api + "/" + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: accessToken,
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson)
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const postFormData = (api = "", data = []) => {
  var form_data = new FormData();

  for (var key in data) {
    form_data.append(key, data[key]);
  }

  let accessToken = getToken();
  if (accessToken !== "") {
    form_data.append("token", accessToken);
  }
  try {
    return fetch(API_ENDPOINT + api, {
      method: "POST",
      headers: {
        //"Accept": "application/json",
        // 'content-type': 'multipart/form-data',
        // 'authorization': accessToken
      },
      body: form_data,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson)
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const updateDataWithFile = (api = "", data = []) => {
  var form_data = new FormData();

  for (var key in data) {
    form_data.append(key, data[key]);
  }

  let accessToken = getToken();
  if (accessToken !== "") {
    form_data.append("token", accessToken);
  }
  try {
    return fetch(API_ENDPOINT + api + "?_method=PUT", {
      method: "POST",
      headers: {
        //"Accept": "application/json",
        // 'content-type': 'multipart/form-data',
        authorization: accessToken,
      },
      body: form_data,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson)
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const postWithFile = (api = "", data: any) => {
  var form_data = new FormData();

  for (var key in data) {
    form_data.append(key, data[key]);
  }

  let accessToken = getToken();
  if (accessToken !== "") {
    form_data.append("token", accessToken);
  }
  try {
    var myHeaders = new Headers();
    myHeaders.append("Cookie", "ci_session=l3o6744nokroic69kg2fn567k94r6dii");

    var requestOptions: any = {
      method: "POST",
      headers: myHeaders,
      body: form_data,
      redirect: "follow",
    };
    return fetch(API_ENDPOINT + api, requestOptions)
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson)
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const logout = () => {
  localStorage.removeItem("vauth");
};

export const setUser = (data: any) => {
  localStorage.setItem("vauth", JSON.stringify(data));
};

export const setOnboarding = (data: any) => {
  localStorage.setItem("onboarding", JSON.stringify(data));
};

export const getOnboarding = () => {
  const onboardingData = localStorage.getItem("onboarding");
  return onboardingData ? JSON.parse(onboardingData) : null;
};

export const getUser = () => {
  let user = localStorage.getItem("vauth");
  if (user) {
    return JSON.parse(user);
  }
  return null;
};

export const getToken = () => {
  let authuser = localStorage.getItem("vauth");
  if (authuser) {
    let user = JSON.parse(authuser);
    return user.token;
  } else {
    return "";
  }
};
export const getExamTypeId = () => {
  let authuser = localStorage.getItem("vauth");
  if (authuser) {
    let user = JSON.parse(authuser);
    return user.exam_type_id;
  } else {
    return "";
  }
};

export const isLoggedIn = () => {
  let checkLogin = localStorage.getItem("auth");
  if (checkLogin) {
    return true;
  }
  return false;
};


export const convertDateTime = (date = "", format = "DD MM YYYY") => {
  if (!date) return "";

  const dateObj = new Date(date);

  const day = String(dateObj.getDate()).padStart(2, "0");
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[dateObj.getMonth()];
  const year = dateObj.getFullYear();

  if (format === "DD MM YYYY") {
    return `${day} ${month} ${year}`;
  }

  return dateObj.toLocaleDateString(); // Fallback for other formats
};

const serialize = function (obj = []) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

export const getObjectById = function (arr: any = [], id = "") {
  console.log(arr, id);
  let index = arr.findIndex((val: any) => {
    return val.value == id;
  });
  if (index > -1) {
    console.log("obj...", arr[index]);
    return arr[index];
  } else {
    return {};
  }
};

export const postDataGuest = (api = "", data = {}) => {
  try {
    return fetch(API_ENDPOINT + api, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        //console.log(responseJson)
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const getRestData = (api = "", data: any = {}) => {
  try {
    return fetch(api, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((responseJson) => {
        return responseJson;
      })
      .catch((error) => {
        console.log(error);
        return error;
      });
  } catch (errors) {
    console.log(errors);
    return errors;
  }
};

export const apiRequest = async (
  endpoint: string,
  payload: any = {},
  method: string = "POST"
) => {
  let url = baseUrl + endpoint;
  const accessToken = getToken();
  const formData = new FormData();
  if (method.toLowerCase() === "get") {
    payload.token = accessToken;
    const params = new URLSearchParams(payload);
    url += "?" + params.toString();
  } else {
    for (let key in payload) {
      formData.append(key, payload[key]);
    }
    if (accessToken !== "") {
      formData.append("token", accessToken);
    }
  }
  return await fetch(url, {
    method,
    body: method.toLowerCase() === "get" ? undefined : formData,
    headers: {
      Accept: "application/json",
    },
  })
    .then(async (resp) => {
      const response = await resp.text();
      try {
        return JSON.parse(response);
      } catch (e) {
        throw JSON.parse(String(response.match(/{.+}/i)?.[0]));
      }
    })
    .catch((err) => {
      throw err;
    });
};

export async function getClientIP() {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
  }
}
